import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken } from "../lib/api";

const AuthContext = createContext({ user: null, loading: true, login: async () => {}, logout: () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = (() => { try { return localStorage.getItem("larcraft_token"); } catch { return null; } })();
    if (token) {
      setAuthToken(token);
      fetchMe();
    } else {
      setLoading(false);
    }
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    try { localStorage.setItem("larcraft_token", data.access_token); } catch (err) { void err; }
    setAuthToken(data.access_token);
    await fetchMe();
    return data;
  };

  const logout = () => {
    try { localStorage.removeItem("larcraft_token"); } catch (err) { void err; }
    setAuthToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
